// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { Container, Header, Icon, Menu, Segment, Sidebar } from "semantic-ui-react";
import "./ApplicationHelp.less";
import * as i18n from "../../config/i18n";
import { ApplicationHelpContextProvider } from "./ApplicationHelpContextProvider";
import { ApplicationFrameContext } from "../ApplicationFrame";
import { ApplicationNavigationContext } from "../ApplicationNavigation";
import { ApplicationError } from "../ApplicationError";
import { ApplicationModule } from "../ApplicationModule";
import { ApplicationHelpModule } from "./ApplicationHelpModule";
import { getApplicationClassName } from "../utils/className";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const className = getApplicationClassName("help");
export const ApplicationHelp = props => {
  const {
    pin,
    onPin
  } = props;
  const container = React.useRef();
  const {
    module,
    feature
  } = React.useContext(ApplicationNavigationContext);
  const {
    help: {
      open,
      setOpen
    }
  } = React.useContext(ApplicationFrameContext);
  const handleShow = React.useCallback(() => {
    if (setOpen) {
      setOpen(true);
    }
  }, [setOpen]);
  const handleHide = React.useCallback(() => {
    if (!pin) {
      if (setOpen) {
        setOpen(false);
      }
    }
  }, [pin, setOpen]);
  const handlePin = React.useCallback(() => {
    onPin?.();
  }, [onPin]);
  const header = React.useMemo(() => /*#__PURE__*/_jsxs(Menu, {
    secondary: true,
    children: [/*#__PURE__*/_jsx(Menu.Item, {
      "data-testid": "help.pin",
      icon: true,
      onClick: handlePin,
      children: /*#__PURE__*/_jsx(Icon, {
        name: "pin",
        color: !pin ? "red" : "black",
        style: {
          transform: `rotateZ(${pin ? 0 : 30}deg)`
        }
      })
    }), /*#__PURE__*/_jsx(Menu.Item, {
      "data-testid": "help.header",
      children: /*#__PURE__*/_jsx(Header, {
        children: i18n.helpHeader
      })
    })]
  }), [pin, handlePin]);
  const content = React.useMemo(() => /*#__PURE__*/_jsxs(ApplicationError, {
    scope: "help",
    dependencies: [feature],
    children: [/*#__PURE__*/_jsx(Container, {
      fluid: true,
      style: {
        ...(feature?.integre && {
          display: "none"
        })
      },
      children: /*#__PURE__*/_jsx("main", {
        ref: container,
        className: module?.code
      })
    }), /*#__PURE__*/_jsx(ApplicationModule, {
      scope: "help",
      container: container,
      name: feature?.components?.help,
      code: module?.code,
      hideSidebar: handleHide,
      showSidebar: handleShow
    })]
  }), [module, feature, handleHide, handleShow]);
  return React.useMemo(() => /*#__PURE__*/_jsx(ApplicationHelpContextProvider, {
    children: /*#__PURE__*/_jsx(Sidebar, {
      className: className,
      as: Segment,
      visible: open,
      animation: pin ? "push" : "overlay",
      direction: "right",
      width: "wide",
      onShow: handleShow,
      onHide: handleHide,
      children: /*#__PURE__*/_jsxs(Container, {
        fluid: true,
        children: [header, /*#__PURE__*/_jsxs(Container, {
          fluid: true,
          children: [/*#__PURE__*/_jsx(Container, {
            className: "stretched",
            children: content
          }), /*#__PURE__*/_jsx(Container, {
            className: "fitted",
            children: /*#__PURE__*/_jsx(ApplicationHelpModule, {})
          })]
        })]
      })
    })
  }), [content, open, pin, header, handleShow, handleHide]);
};